define(function (require) {
	//views
	const locationPickerView = require('./location_picker/v_lov_location_picker');
	const MapView = require('civicsViews/agencymap_view/v_agencymap');
	const mapToggleView = require('./v_lov_map_toggle');
	const selectedSitesView = require('./selected_sites/v_lov_selected_sites');
	const confirmationModal = require('civicsViews/confirmation_modal/v_lov_confirmation_modal');

	//templates
	const tpl = require('./t_lov_location_selection.hbs');

	//models
	const IPSModel = require('civicsBase/ipsModel');
	const IPSCollection = require('civicsBase/ipsModelCollection');

	//Utilities
	const view_manager = require('civicsUtils/view_manager');
	const ModalRegion = require('civicsUtils/modal_region');
	const general_utilities = require('civicsUtils/general_utilities');

	//This needs to be moved into the common utilities.
	const loading_manager = require('civicsUtils/loading_manager');

	//extensions - (See bottom of file)
	const main_location_logic = require('./logic/main_logic');
	const CN = require('civicsUtils/constants');

	/********************************************************************* */
	/* 	IMPORTANT: This object is extended in main_location_logic.	   */
	/*	If you can't find this.whatever in this file, look there.		   */
	/********************************************************************* */
	return Marionette.LayoutView.extend({
		className: "location-selection",
		extent: '',
		template: tpl,
		regions: {
			locationPickerRegion:'@ui.locationPickerRegionDiv',
			mapRegion: '@ui.mapRegionDiv',
			mapToggleRegion: '@ui.mapToggle',
			selectedSitesRegion:'@ui.selectedSitesRegionDiv',
			mobileNewLocationRegion:'@ui.mobileNewLocationDiv',
			locationDetailsRegion:'@ui.locationDetailsRegionDiv',
			modalRegion: {
				regionClass: ModalRegion,
				selector: 'body .rhythm-modals'
			},
		},
		ui: {
			autocompleteCombinedSiteInput: '.autocomplete-combined-site input',
			autocompleteCombinedSiteLabel: '.autocomplete-combined-site label',
			combinedSiteWrapper: '.combined-site-wrapper',
			leftSide: '.left-side',
			locateMeButton: '.locate-me',
			locationDetailsTextArea: 'textarea.site-location-details',
			locationPickerRegionDiv:'.location-picker-region',
			locationDetailsRegionDiv:'.location-details-region',
			mapRegionDiv: '.myProjectMap',
			mapToggle: '.map-toggle-region',
			mapWrapper: '.map-wrapper',
			locationPicker: '.location-picker-region',
			messagesDiv: '.address-field-wrapper .messages',
			parcelWrapper: '.parcel-wrapper',
			selectedSitesRegionDiv:'.selected-sites-region',
			//mobile
			mobileNewLocationDiv:'.mobile-display-only-location-wrapper',
			newLocationWrapper:'.new-location-wrapper',
			mobileOpenButton:'.mobile-open-button',
			mobileCloseButton:'.mobile-close-button',
			addLocationDetailsButton:'.add-loc-button',
			doneLocationDetailsButton:'.done-details-button',
			doneMobileButton:'.done-button'
		},
		childEvents:{
			'open:mobile':'openMobileFullScreen',
			'map:toggled':'positionViewsOnToggleChange'
		},
		events: {
			'focus @ui.locationDetailsTextArea': 'onLocationDetailsFocus',
			'keyup @ui.autocompleteCombinedSiteInput': 'autocompleteFieldsTyping',
			'click @ui.mobileOpenButton':'openMobileFullScreen',
			'click @ui.mobileCloseButton':'closeMobileFullScreen',
			'click @ui.doneMobileButton':'closeMobileFullScreen',

			'click @ui.addLocationDetailsButton':'addLocationDetailsMobile',
			'click @ui.doneLocationDetailsButton':'doneDetailsButtonMobile'

		},
		activeMapLayers:null,
		viewReady:false,
		views:{},
		initialize: function (options) {
			this.config = _.isEmpty(options.config) ? {} : options.config;
			this.portletName = options.portletName;
			this.assetsOnMapEnabled = true;
			this.providedLocationDetails = options.providedLocationDetails;
			if (_.isEmpty(this.config.globalConfig)) {
				this.config.globalConfig = view_manager.globalConfig().toJSON();
			}
			this.countryCode = this.getCountryCode(this.config.globalConfig.cultureInfo);

			//used to ensure we don't try to alter the UI before render finishes.
			//The location services will clear/fill the autocomplete field, and can finish before the render.
			this.isRenderedPromise = $.Deferred();
			this.mapReadyPromise = $.Deferred();
			this.mapExtentPromise = $.Deferred();
			this.locationServicesAvailablePromise = $.Deferred();

			this.primarySiteHiddenByConstraints = this.checkSiteConstraints(true,this.config);
			this.additionalSitesHiddenByConstraints = this.checkSiteConstraints(false,this.config);

			//nearbySitesCollection is view state, not a render artifact. It must exist for the
			//lifetime of the view so async map-click results can never write to an undefined collection.
			this.nearbySitesCollection = new Backbone.Collection();

			//selectedSitesCollection is view state, not a render artifact. It must exist for the
			//lifetime of the view so a map click (or autocomplete selection) that fires before the
			//async setupSelectedSites() resolves can never read from an undefined collection.
			//setupSelectedSites() populates this same instance rather than reassigning it.
			this.selectedSitesCollection = new Backbone.Collection();

			this.setupMapAndExtent(options);
			this.setupLocationServices();
			//we have to build the layer list, so that this.activeMapLayers is built, and can filter
			//the layers on the maplet or the calls to the extent services or AC services
			this.buildLayerList(this.config.primarySiteType, this.config.additionalSiteType, this.config.portalAssetTypes)

			this.setupSelectedSitesPromise = this.setupSelectedSites();
			
		},
		onRender: function () {
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();
			this.setupSelectedSitesPromise.done(()=>{
				this.isRenderedPromise.resolve();
				this.updatePrimaryVsAdditionalSiteMessaging();
			});
			
		},
		onShow: function () {
			this.handleOverlay();
			$.when(this.mapExtentPromise).always(() => {
				//TO DO: REMOVE SECOND PARAMETER, NO LONGER NEEDED
				this.setupAutocomplete(this.config.cdrNewLocation.compositeMoniker, {}, this.config.cdrNewLocation.searchExtentSize, this.config.primarySiteType, this.config.portalAssetTypes);
			})

			this.displayMap();
			$.when(this.mapReadyPromise, this.setupSelectedSitesPromise).done(() =>{

				if (this.assetsOnMapEnabled) {
					// event that updates layers on visibility change
					this.listenTo(this, 'civics:layer-visible', (mapLayers) => {
						this.updateMapLayers(mapLayers);
					});
					// gets active layers on map render
					this.listenTo(this, 'civics:get-active-layers', (mapLayers) => {
						this.updateMapLayers(mapLayers);
					});
		
				}
				this.updateMapLayers(this.activeMapLayers);


			})
			this.on('civics:map-click-results', (res) => {
				this.mapClicked(res, this.config.cdrNewLocation.searchExtentSize);
				this.views.selectedSitesView.triggerMethod('closeMobileView');
				this.displayLocationPicker();

			});
			this.on('civics:locate-me-clicked', (res) => {
				this.locateMeClicked();
			});
			//this sets up the event handling for no results from autocomplete
			if (this.assetsOnMapEnabled) {
				this.ui.autocompleteCombinedSiteInput.on('requestend', this.autocompleteRequestCompleted.bind(this));
			}

			this.ui.locationDetailsTextArea.val(this.providedLocationDetails);
			this.ui.locationDetailsTextArea.maxlength();
			this.displaySelectedSites();

			//this will set the display of the selected sites to be a modal when the map is enabled, and inline when not.
			this.positionViewsOnToggleChange();
		},
		displayLocationPicker: function(){
			//nearbySitesCollection is created once in initialize(); bind the picker to that
			//persistent instance rather than re-creating it here (which caused a timing race).
			this.views.locationPickerView = new locationPickerView({
				config: this.config,
				collection: this.nearbySitesCollection,
				pickerRegion: this.locationPickerRegion,
				selectedSitesCollection: this.selectedSitesCollection,
				parentView: this
			})

			this.locationPickerRegion.show(this.views.locationPickerView);		
		},
		closeLocationPicker:function(){
			if(this.nearbySitesCollection){
				this.nearbySitesCollection.reset();
			}
		},
		displaySelectedSites:function(){

			this.setupSelectedSitesPromise.done(()=>{
				//interactive selected sites over the map
				this.views.selectedSitesView = new selectedSitesView({
					collection:this.selectedSitesCollection,
					config:this.config
				});
				this.selectedSitesRegion.show(this.views.selectedSitesView);

				//static selected site displayed in the flow of add instrument
				this.views.mobileNewLocationView = new selectedSitesView({
					collection:this.selectedSitesCollection,
					interactive:false,
					config:this.config
				});
				this.mobileNewLocationRegion.show(this.views.mobileNewLocationView);
			})
			
		},
		onLocationDetailsFocus: function () {
			if ($(".additional-information-wrapper").find('.helper-msg').length == 0) {
				this.ui.locationDetailsTextArea.maxlength();
			}//return character counter
		},
		autocompleteFieldsTyping: function () {
			var oldVal = this.ui.autocompleteCombinedSiteInput.data('oldValue');
			var val = this.ui.autocompleteCombinedSiteInput.val();
			//check that the oldvalue and the current value don't match. this means they typed something, as opposed to just navigating the text string with arrow keys
			//also check to see if val is short/less than the number of characters to trigger autocomplete. We still want to clear messages and reset the object in that case.
			// if ((oldVal != undefined && oldVal != val) || (val != undefined && val.length <= 3)) {
			// 	//first argument is the method being used currently, second is whether to keep the autocomplete field populated
			// 	this.resetLocation({ autocomplete: true }, true);
			// }
		},
		updatePrimaryVsAdditionalSiteMessaging:function(){
			let havePrimary = this.primarySiteSelected();
			let canAddMoreSites = !this.additionalSitesHiddenByConstraints;
			
			let requiredAsterisk = this.isCurrentSiteFieldRequired(!havePrimary,this.config.validation) ? '<em class="required">*</em>' : '';
			if(havePrimary){
				if(canAddMoreSites){// add additional sites messaging
					this.ui.autocompleteCombinedSiteLabel.text(i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.ADD_ADDITIONAL_SITE'));
					this.ui.autocompleteCombinedSiteInput.attr('placeholder',i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.START_TYPING_OR_USE_MAP'));
					this.ui.autocompleteCombinedSiteLabel.append(requiredAsterisk);
				} else {//change primary site messaging
					//this will never be required, since being here implies we already have a primary site, and can't have additional sites
					this.ui.autocompleteCombinedSiteLabel.text(i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.CHANGE_PRIMARY_SITE'));
					this.ui.autocompleteCombinedSiteInput.attr('placeholder',i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.START_TYPING_OR_USE_MAP_TO_CHANGE'));
				}
			} else {//add primary site messaging
				this.ui.autocompleteCombinedSiteLabel.text(i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.COMBINED_ADD_LABEL'));
				this.ui.autocompleteCombinedSiteInput.attr('placeholder', i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.COMBINED_SITE_PLACEHOLDER'));
				this.ui.autocompleteCombinedSiteLabel.append(requiredAsterisk);
			}
		},
		//fires whenever the AC service fetch finishes. we only want to do anything if it's empty.
		autocompleteRequestCompleted: function (args, typedText, response) {
			if (response && response.length == 0) {
				this.showError(i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.COMBINED_NO_RESULTS_RETURNED_ERROR'))
			}
		},
		clearAutocomplete: function () {
			//if the view hasn't been rendered, there isn't anything to clear anyways. no need to set up a .done
			if (this.isRenderedPromise.state() == 'resolved') {
				this.ui.autocompleteCombinedSiteInput.val('');
				this.ui.autocompleteCombinedSiteInput.removeData('oldValue');
			}
		},
		displayMap: function () {
			if (this.mapEnabled) {
				this.mapRegion.show(new MapView({
					config: {
						mapConfig: this.mapConfigName,
						channel: this,
						regionId: this.mapRegionId,
					},
					layerList: this.activeMapLayers,
				}));
				this.mapToggleModel = new IPSModel({ mapToggle: true });
				this.mapToggleModel.on('change', () => {
					if (this.mapToggleModel.get('mapToggle')) {
						this.ui.mapWrapper.show(250);
					} else {
						this.ui.mapWrapper.hide(250);
					}
				});
				this.mapToggleRegion.show(new mapToggleView({ mapStateName: this.mapStateName, model: this.mapToggleModel, parent: this }));


			} else {
				this.ui.mapWrapper.hide();
				this.ui.leftSide.hide();
			}
		},
		handleOverlay: function () {
			this.showLoadingOverlay(true);
			//place an overlay while the map is loading. Then continue to show it until all the init calls are finished.
			$.when(this.mapReadyPromise, this.mapExtentPromise, this.locationServicesAvailablePromise, this.setupSelectedSitesPromise).always(() => {
				this.showLoadingOverlay(false);
			});
		},
		showLoadingOverlay(show){
			let view = this.$el.find('.new-location-wrapper.visible').length == 1 ? {$el:this.$el.find('.new-location-wrapper.visible')} : this;
			loading_manager.loading(show, view);
		},
		openModal:function(title,text, okText, okCallback, cancelText){
			this.modalRegion.show(new confirmationModal({
				title:title,
				instructions:text,
				submitButtonText:okText,
				hideSubmitButton:okText == "",
				cancelButtonText:cancelText,
				confirmationCallback:okCallback,
				closeAfterSubmit:true
			}));
			this.modalRegion.showModal();
		},
		setupLocationServices: function () {
			this.useLocationServices = this.config.cdrNewLocation.useLocationServices === true;

			if (this.useLocationServices) {
				this.mapExtentPromise.done(() => {
					//we're grabbing the users location, and passing through whatever is returned in the resolve to the locationservicesAvialable promise.
					this.getUsersLocation(this.extent, this.config.globalConfig.gis.locateMeTimeout).done((coords) => {
						this.locationServicesAvailablePromise.resolve(coords);
					});
				});
			} else {
				this.locationServicesAvailablePromise.resolve(false);
			}

			//these three promises will ALWAYS resolve, regardless of the map, location, or extent status. Once these are resolved, teh view is ready
			//but if we're cloning and have a provided primary site, that sites data will still be fetching.
			$.when(this.locationServicesAvailablePromise, this.mapExtentPromise, this.mapReadyPromise).done(() => {
				//for whatever reason we cant get teh parameters from the promise in a when. Even though we should be able to.
				this.locationServicesAvailablePromise.done((coords) => {
					if (coords !== false) {
						this.showLocateMeButton(true);
						if (this.selectedSitesCollection.length == 0) {//don't show users location if we have a site to show already, either from clone or saved instrument
							this.centerMapOnCoordinatesAndPlacePin(coords);
						}
					} else {
						this.showLocateMeButton(false);
					}
					if (!this.locationServicesAvailable) {
						$('.map-panel.locate-me').hide();
					}
				});
				if(this.selectedSitesCollection && this.selectedSitesCollection.length>0){
					this.selectedSitesCollection.trigger('update');
				}
				this.viewReady = true;
			});
		},
		showLocateMeButton: function (show) {
			this.locationServicesAvailable = show;
		},
		locateMeClicked: function (e) {
			if (e) {
				e.stopPropagation();
				e.preventDefault();
			}

			var locateMePromise = this.getUsersLocation(this.extent, this.config.globalConfig.gis.locateMeTimeout);
			locateMePromise.done((coords) => {
				if (coords !== false) {
					this.centerMapOnCoordinatesAndPlacePinWithSelectedSites(coords);
				} else {//this code should never really fire. If the location is outside of the extent, the locate me button should be hidden.
					this.showError(i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.OUT_OF_EXTENT_ERROR_LOCATE_ME'));
				}
			})
		},
		resetErrorMessages: function () {
			view_manager.resetErrorMessages(this);
		},
		setFieldToValue(displayText) {
			var field = this.ui.autocompleteCombinedSiteInput;
			if (this.isRenderedPromise.state() == 'resolved') {
				field.val(displayText);
				//set the address display text to "oldValue" so we can compare it on keyup events.
				//if it hasn't changed, don't clear the location object.
				field.data('oldValue', displayText);
			} else {
				this.isRenderedPromise.done(() => {
					this.setFieldToValue(displayText);
				})
			}
		},
		setupMapAndExtent: function (options) {
			this.mapStateName = options.mapStateName;
			this.mapConfigName = options.mapConfigName;
			this.mapRegionId = options.mapRegionId;
			this.mapEnabled = (!_.isEmpty(this.config.globalConfig.gis) ? this.config.globalConfig.gis.enabled : false) && !_.isEmpty(this.mapConfigName);

			if (this.mapEnabled) {
				this.fetchMapExtent(this.mapConfigName)
					.done((response) => {
						if (response.extent) {
							this.extent = response.extent;
							this.mapExtentPromise.resolve();
						} else {
							//our backup option is to use the extent from the portlet config
							this.extent = this.getExtentFromConfig(this.config);
							this.mapExtentPromise.resolve();
						}
					})
					.fail(() => {
						this.extent = this.getExtentFromConfig(this.config);
						this.mapExtentPromise.resolve();
					});
				this.mapState = view_manager.getMapState('CIVICS', this.mapStateName);


				this.on("map:ready", function () {
					setTimeout(() => {
						this.mapReadyPromise.resolve();
					}, 500);

				}.bind(this));

				this.on("map:adminfailure", function () {
					setTimeout(() => {
						this.mapReadyPromise.resolve();
					}, 500);

				}.bind(this));
			} else {
				//if the map is disabled, we still need an extent for the autocomplete. we can get that from the config.
				this.extent = this.getExtentFromConfig(this.config);
				this.mapExtentPromise.resolve();
				this.mapReadyPromise.resolve();
			}
		},
		showError: function (errorText) {
			var errorObj = {};
			errorObj[this.ui.autocompleteCombinedSiteInput.attr('name')] = errorText;
			view_manager.errorToWindow({
				validationError: errorObj
			}, this);
		},
		submitData:function() {
			let location = this.ui.locationDetailsTextArea.val();
			return this.processLocationData(location);
		},
		positionViewsOnToggleChange:function(){
			if(this.mapToggleModel && !this.mapToggleModel.get('mapToggle') || !this.mapEnabled){
				this.ui.selectedSitesRegionDiv.addClass("map-off");
				this.ui.locationPickerRegionDiv.addClass("map-off");

			}else{
				this.ui.selectedSitesRegionDiv.removeClass("map-off");
				this.ui.locationPickerRegionDiv.removeClass("map-off");

			}
		},
		openMobileFullScreen:function(e){
			if(e && e.stopPropagation){
				e.stopPropagation();
				e.preventDefault();
			}
			this.ui.newLocationWrapper.addClass('visible');
		},
		closeMobileFullScreen:function(e){
			if(e && e.stopPropagation){
				e.stopPropagation();
				e.preventDefault();
			}
			this.ui.newLocationWrapper.removeClass('visible');

		},
		addLocationDetailsMobile:function(e){
			if(e && e.stopPropagation){
				e.stopPropagation();
				e.preventDefault();
			}

			this.ui.locationDetailsRegionDiv.addClass('visible');

		},
		doneDetailsButtonMobile:function(e){
			if(e && e.stopPropagation){
				e.stopPropagation();
				e.preventDefault();
			}
			this.ui.locationDetailsRegionDiv.removeClass('visible');

		},
		showToastMessage:function(message){
			const SUCCESS = 'success';
			
			//if we don't have a selected-sites-content-div, that means we just deleted the last site. No pup up will appear, 
			//but it's clear the site was removed because of the drastic change in the ui.
			
				//we use set timeout so we don't collide with the view re-rendering.
				setTimeout(()=>{	
					let notificationDiv = this.ui.selectedSitesRegionDiv.find('.map-overlay-region');
					if(notificationDiv.length==1){
						general_utilities.civicsToastPop(message, SUCCESS, 5000, notificationDiv);
					}
				},100);
		},
		templateHelpers: function () {
			return {
				mapEnabled: true,
				locationServicesAvailable: this.locationServicesAvailable,
				hideOrShowLocateMeButton: this.locationServicesAvailable ? "" : " hide",
				primarySiteHidden: this.config.constraints && this.config.constraints.primarySite && (this.config.constraints.primarySite.hidden || this.config.constraints.primarySite.readOnly),
				locationDetailsHidden: this.config.constraints && this.config.constraints.primarySite && this.config.constraints.primarySite.hidden,
				locationDetailsDisabled: this.config.constraints && this.config.constraints.primarySite && this.config.constraints.primarySite.readOnly,
				hideCombinedSite: this.primarySiteHiddenByConstraints && this.additionalSitesHiddenByConstraints ? " hidden" : ""
			}
		}
	}).extend(main_location_logic);
});
